// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
}

:host .btn::after {
  content: none !important;
  display: none !important;
}

.type-page {
  background: var(--background-gray, var(--light));
  box-sizing: border-box;
  flex: 1 1 auto;
  margin: 0 auto !important;
  max-width: 1920px !important;
  min-height: 0;
  min-width: 0;
  overflow: auto;
  padding: 0.65rem clamp(0.65rem, 2vw, 1.4rem) 0.75rem;
  width: 96% !important;
}

.type-actions-bar {
  display: flex;
}

.back-action {
  align-items: center;
  background: #fff !important;
  border: 1px solid var(--primary) !important;
  color: var(--primary) !important;
  display: inline-flex;
  gap: 0.5rem;
  margin: 0 0 0.65rem;
  padding: 0.45rem 0.8rem;
}

.back-action:hover, .back-action:focus-visible {
  background: var(--primary) !important;
  color: #fff !important;
}

.back-action mat-icon {
  font-size: 1.15rem;
  height: 1.15rem;
  line-height: 1.15rem;
  width: 1.15rem;
}

.type-heading {
  align-items: center;
  background: #fff;
  border: 1px solid #dee2e6;
  border-left: 4px solid var(--primary);
  border-radius: 7px;
  display: flex;
  margin: 0 0 1.2rem !important;
  min-height: 58px;
  padding: 0.9rem clamp(1rem, 3vw, 2rem);
  text-align: center;
}

.type-heading::before, .type-heading::after {
  content: none !important;
  display: none !important;
}

.type-heading__title {
  flex: 1 1 auto;
}

.type-heading h1 {
  color: var(--dark);
  font-size: 1.65rem;
  font-weight: 700;
  line-height: 1.15;
  margin: 0;
}

.matrix-controls {
  align-items: center;
  display: flex;
  gap: 12px;
  justify-content: space-between;
  margin-bottom: 10px;
}

.type-create {
  align-items: center;
  display: flex;
  flex: 1 1 auto;
  gap: 12px;
  min-width: 0;
}

.type-create mat-form-field {
  flex: 0 1 360px;
  min-width: 0;
}

.type-create button {
  align-items: center;
  display: inline-flex;
  gap: 6px;
}

.matrix-toolbar {
  display: flex;
  flex: 0 0 auto;
  justify-content: flex-end;
}

.matrix-toolbar button {
  align-items: center;
  display: inline-flex;
  gap: 6px;
}

.matrix-toolbar mat-icon {
  font-size: 1.1rem;
  height: 1.1rem;
  line-height: 1.1rem;
  width: 1.1rem;
}

.error-message {
  border-left: 3px solid var(--danger);
  color: var(--danger);
  padding: 10px;
}

.matrix-scroll {
  border: 1px solid #dce1e5;
  min-width: 100%;
  width: max-content;
}

.type-matrix {
  border-collapse: separate;
  border-spacing: 0;
  font-size: 0.83rem;
  width: max-content;
}

.type-matrix th, .type-matrix td {
  background: #fff;
  border-bottom: 1px solid #e3e7eb;
  border-right: 1px solid #e3e7eb;
  padding: 6px;
}

.type-matrix thead th {
  background: #f0f3f5;
  position: sticky;
  top: 0;
  z-index: 2;
}

.matrix-title-row th {
  height: 44px;
}

.type-matrix thead .matrix-title {
  background: #fff;
  text-align: center;
}

.matrix-title strong {
  color: var(--dark);
  display: block;
  font-size: 0.85rem;
}

.matrix-title small {
  color: var(--secondary);
  display: block;
  font-size: 0.7rem;
}

.type-matrix thead .period-row th {
  height: 44px;
  top: 44px;
}

.type-matrix thead .calibration-title-row th {
  top: 88px;
}

.period-weekly {
  --period-bg: #e6f3f0;
  --period-hover-bg: #d4eae4;
  --period-accent: #237667;
}

.period-monthly {
  --period-bg: #e9f2f9;
  --period-hover-bg: #d7e9f5;
  --period-accent: #326c96;
}

.period-quarterly {
  --period-bg: #eef4e6;
  --period-hover-bg: #e1edcf;
  --period-accent: #607f39;
}

.period-annual {
  --period-bg: #f9efe2;
  --period-hover-bg: #f4e4cb;
  --period-accent: #946327;
}

.type-matrix thead .period-band, .type-matrix thead .calibration-column {
  background: var(--period-bg);
}

.period-band {
  border-top: 3px solid var(--period-accent);
  color: var(--period-accent);
  font-weight: 700;
  text-align: center;
}

.type-column {
  left: 0;
  min-width: 340px;
  position: sticky;
  text-align: left;
  width: 340px;
  z-index: 1;
}

.type-matrix thead .type-column {
  z-index: 3;
}

.type-axis {
  align-items: center;
  display: inline-flex;
  gap: 8px;
}

.type-axis mat-icon {
  color: var(--primary);
  font-size: 18px;
  height: 18px;
  width: 18px;
}

.type-matrix tbody tr {
  height: 52px;
}

.type-content {
  align-items: center;
  display: flex;
  gap: 4px;
  width: 100%;
}

.type-name {
  flex: 1 1 auto;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.type-actions {
  display: inline-flex;
  flex: 0 0 auto;
}

.edit-name {
  flex: 1 1 auto;
  min-width: 0;
  width: 100%;
}

.calibration-column {
  height: 330px;
  max-width: 48px;
  min-width: 48px;
  padding: 4px !important;
  text-align: center;
  vertical-align: middle;
  width: 48px;
}

.calibration-column span {
  display: block;
  height: 310px;
  margin: 0 auto;
  overflow-wrap: anywhere;
  text-align: center;
  transform: rotate(180deg);
  white-space: normal;
  writing-mode: vertical-rl;
}

.type-matrix thead .calibration-column--active {
  background: var(--period-hover-bg);
  box-shadow: inset 0 0 0 2px var(--period-accent);
  z-index: 4;
}

.calibration-column--active span {
  background: #fff;
  border: 2px solid var(--period-accent);
  bottom: 10px;
  box-shadow: 0 3px 12px rgba(0, 0, 0, 0.1333333333);
  box-sizing: border-box;
  height: auto;
  left: 50%;
  max-width: min(260px, 100vw - 32px);
  overflow-wrap: anywhere;
  padding: 10px 12px;
  position: absolute;
  transform: translateX(-50%);
  white-space: normal;
  width: max-content;
  writing-mode: horizontal-tb;
}

.calibration-cell {
  height: 48px;
  text-align: center;
  width: 48px;
}

.calibration-cell--active {
  background: var(--period-hover-bg) !important;
  box-shadow: inset 0 0 0 2px var(--period-accent);
}

.type-matrix tbody .type-column--active {
  background: var(--period-hover-bg);
  box-shadow: inset 0 0 0 2px var(--period-accent);
}

.save-column {
  max-width: 72px;
  min-width: 72px;
  padding: 3px !important;
  text-align: center;
  width: 72px;
}

.inactive > th, .inactive > td {
  background: #f2f3f4;
  color: #6c757d;
}

.empty-row {
  padding: 20px !important;
  text-align: center;
}

@media (max-width: 700px) {
  .type-page {
    padding: 0.65rem;
    width: 100% !important;
  }
  .matrix-controls {
    align-items: stretch;
    flex-wrap: wrap;
  }
  .matrix-toolbar {
    margin-left: auto;
  }
}
@media (max-width: 600px) {
  .type-column {
    min-width: 260px;
    width: 260px;
  }
  .type-heading h1 {
    font-size: 1.3rem;
  }
}`, "",{"version":3,"sources":["webpack://./projects/cemsys/src/app/lab-equipment/instrument-type-matrix.component.scss"],"names":[],"mappings":"AAAA;EAAQ,aAAA;EAAe,cAAA;EAAgB,aAAA;AAIvC;;AAHA;EAAoB,wBAAA;EAA0B,wBAAA;AAQ9C;;AAPA;EACC,gDAAA;EACA,sBAAA;EACA,cAAA;EACA,yBAAA;EACA,4BAAA;EACA,aAAA;EACA,YAAA;EACA,cAAA;EACA,oDAAA;EACA,qBAAA;AAUD;;AARA;EAAoB,aAAA;AAYpB;;AAXA;EAAe,mBAAA;EAAqB,2BAAA;EAA6B,2CAAA;EAA6C,gCAAA;EAAkC,oBAAA;EAAsB,WAAA;EAAY,mBAAA;EAAoB,uBAAA;AAsBtM;;AArBA;EAAiD,qCAAA;EAAuC,sBAAA;AA0BxF;;AAzBA;EAAwB,kBAAA;EAAoB,eAAA;EAAiB,oBAAA;EAAsB,cAAA;AAgCnF;;AA/BA;EAAgB,mBAAA;EAAqB,gBAAA;EAAkB,yBAAA;EAA2B,qCAAA;EAAuC,kBAAA;EAAoB,aAAA;EAAe,6BAAA;EAA+B,gBAAA;EAAkB,sCAAA;EAAuC,kBAAA;AA4CpP;;AA3CA;EAA8C,wBAAA;EAA0B,wBAAA;AAgDxE;;AA/CA;EAAuB,cAAA;AAmDvB;;AAlDA;EAAmB,kBAAA;EAAoB,kBAAA;EAAoB,gBAAA;EAAkB,iBAAA;EAAmB,SAAA;AA0DhG;;AAzDA;EAAmB,mBAAA;EAAqB,aAAA;EAAe,SAAA;EAAW,8BAAA;EAAgC,mBAAA;AAiElG;;AAhEA;EAAe,mBAAA;EAAqB,aAAA;EAAe,cAAA;EAAgB,SAAA;EAAW,YAAA;AAwE9E;;AAvEA;EAA8B,eAAA;EAAiB,YAAA;AA4E/C;;AA3EA;EAAsB,mBAAA;EAAqB,oBAAA;EAAsB,QAAA;AAiFjE;;AAhFA;EAAkB,aAAA;EAAe,cAAA;EAAgB,yBAAA;AAsFjD;;AArFA;EAAyB,mBAAA;EAAqB,oBAAA;EAAsB,QAAA;AA2FpE;;AA1FA;EAA2B,iBAAA;EAAmB,cAAA;EAAgB,mBAAA;EAAqB,aAAA;AAiGnF;;AAhGA;EAAiB,oCAAA;EAAsC,oBAAA;EAAsB,aAAA;AAsG7E;;AArGA;EAAiB,yBAAA;EAA2B,eAAA;EAAiB,kBAAA;AA2G7D;;AA1GA;EAAe,yBAAA;EAA2B,iBAAA;EAAmB,kBAAA;EAAmB,kBAAA;AAiHhF;;AAhHA;EAAmC,gBAAA;EAAkB,gCAAA;EAAkC,+BAAA;EAAiC,YAAA;AAuHxH;;AAtHA;EAAwB,mBAAA;EAAqB,gBAAA;EAAkB,MAAA;EAAQ,UAAA;AA6HvE;;AA5HA;EAAuB,YAAA;AAgIvB;;AA/HA;EAAmC,gBAAA;EAAkB,kBAAA;AAoIrD;;AAnIA;EAAuB,kBAAA;EAAoB,cAAA;EAAgB,kBAAA;AAyI3D;;AAxIA;EAAsB,uBAAA;EAAyB,cAAA;EAAgB,iBAAA;AA8I/D;;AA7IA;EAAoC,YAAA;EAAc,SAAA;AAkJlD;;AAjJA;EAA+C,SAAA;AAqJ/C;;AApJA;EAAiB,oBAAA;EAAsB,0BAAA;EAA4B,wBAAA;AA0JnE;;AAzJA;EAAkB,oBAAA;EAAsB,0BAAA;EAA4B,wBAAA;AA+JpE;;AA9JA;EAAoB,oBAAA;EAAsB,0BAAA;EAA4B,wBAAA;AAoKtE;;AAnKA;EAAiB,oBAAA;EAAsB,0BAAA;EAA4B,wBAAA;AAyKnE;;AAxKA;EAA0E,4BAAA;AA4K1E;;AA3KA;EAAe,0CAAA;EAA4C,2BAAA;EAA6B,gBAAA;EAAkB,kBAAA;AAkL1G;;AAjLA;EAAe,OAAA;EAAS,gBAAA;EAAkB,gBAAA;EAAkB,gBAAA;EAAkB,YAAA;EAAc,UAAA;AA0L5F;;AAzLA;EAAkC,UAAA;AA6LlC;;AA5LA;EAAa,mBAAA;EAAqB,oBAAA;EAAsB,QAAA;AAkMxD;;AAjMA;EAAsB,qBAAA;EAAuB,eAAA;EAAiB,YAAA;EAAc,WAAA;AAwM5E;;AAvMA;EAAwB,YAAA;AA2MxB;;AA1MA;EAAgB,mBAAA;EAAqB,aAAA;EAAe,QAAA;EAAU,WAAA;AAiN9D;;AAhNA;EAAa,cAAA;EAAgB,YAAA;EAAc,gBAAA;EAAkB,uBAAA;EAAyB,mBAAA;AAwNtF;;AAvNA;EAAgB,oBAAA;EAAsB,cAAA;AA4NtC;;AA3NA;EAAa,cAAA;EAAgB,YAAA;EAAc,WAAA;AAiO3C;;AAhOA;EAAsB,aAAA;EAAe,eAAA;EAAiB,eAAA;EAAiB,uBAAA;EAAyB,kBAAA;EAAoB,sBAAA;EAAwB,WAAA;AA0O5I;;AAzOA;EAA2B,cAAA;EAAgB,aAAA;EAAe,cAAA;EAAgB,uBAAA;EAAyB,kBAAA;EAAoB,yBAAA;EAA2B,mBAAA;EAAqB,yBAAA;AAoPvK;;AAnPA;EAAiD,kCAAA;EAAoC,gDAAA;EAAkD,UAAA;AAyPvI;;AAxPA;EACC,gBAAA;EACA,sCAAA;EACA,YAAA;EACA,kDAAA;EACA,sBAAA;EACA,YAAA;EACA,SAAA;EACA,mCAAA;EACA,uBAAA;EACA,kBAAA;EACA,kBAAA;EACA,2BAAA;EACA,mBAAA;EACA,kBAAA;EACA,2BAAA;AA2PD;;AAzPA;EAAoB,YAAA;EAAc,kBAAA;EAAoB,WAAA;AA+PtD;;AA9PA;EAA4B,6CAAA;EAA+C,gDAAA;AAmQ3E;;AAlQA;EAA0C,kCAAA;EAAoC,gDAAA;AAuQ9E;;AAtQA;EAAe,eAAA;EAAiB,eAAA;EAAiB,uBAAA;EAAyB,kBAAA;EAAoB,WAAA;AA8Q9F;;AA7QA;EAAiC,mBAAA;EAAqB,cAAA;AAkRtD;;AAjRA;EAAa,wBAAA;EAA0B,kBAAA;AAsRvC;;AArRA;EAA4B;IAAa,gBAAA;IAAiB,sBAAA;EA2RxD;EA3RkF;IAAmB,oBAAA;IAAsB,eAAA;EA+R3H;EA/R8I;IAAkB,iBAAA;EAkShK;AACF;AAlSA;EAA4B;IAAe,gBAAA;IAAkB,YAAA;EAuS3D;EAvS2E;IAAmB,iBAAA;EA0S9F;AACF","sourcesContent":[":host { display: flex; flex: 1 1 auto; min-height: 0; }\n:host .btn::after { content: none !important; display: none !important; }\n.type-page {\n\tbackground: var(--background-gray, var(--light));\n\tbox-sizing: border-box;\n\tflex: 1 1 auto;\n\tmargin: 0 auto !important;\n\tmax-width: 1920px !important;\n\tmin-height: 0;\n\tmin-width: 0;\n\toverflow: auto;\n\tpadding: 0.65rem clamp(0.65rem, 2vw, 1.4rem) 0.75rem;\n\twidth: 96% !important;\n}\n.type-actions-bar { display: flex; }\n.back-action { align-items: center; background: #fff !important; border: 1px solid var(--primary) !important; color: var(--primary) !important; display: inline-flex; gap: .5rem; margin: 0 0 .65rem; padding: .45rem .8rem; }\n.back-action:hover, .back-action:focus-visible { background: var(--primary) !important; color: #fff !important; }\n.back-action mat-icon { font-size: 1.15rem; height: 1.15rem; line-height: 1.15rem; width: 1.15rem; }\n.type-heading { align-items: center; background: #fff; border: 1px solid #dee2e6; border-left: 4px solid var(--primary); border-radius: 7px; display: flex; margin: 0 0 1.2rem !important; min-height: 58px; padding: .9rem clamp(1rem, 3vw, 2rem); text-align: center; }\n.type-heading::before, .type-heading::after { content: none !important; display: none !important; }\n.type-heading__title { flex: 1 1 auto; }\n.type-heading h1 { color: var(--dark); font-size: 1.65rem; font-weight: 700; line-height: 1.15; margin: 0; }\n.matrix-controls { align-items: center; display: flex; gap: 12px; justify-content: space-between; margin-bottom: 10px; }\n.type-create { align-items: center; display: flex; flex: 1 1 auto; gap: 12px; min-width: 0; }\n.type-create mat-form-field { flex: 0 1 360px; min-width: 0; }\n.type-create button { align-items: center; display: inline-flex; gap: 6px; }\n.matrix-toolbar { display: flex; flex: 0 0 auto; justify-content: flex-end; }\n.matrix-toolbar button { align-items: center; display: inline-flex; gap: 6px; }\n.matrix-toolbar mat-icon { font-size: 1.1rem; height: 1.1rem; line-height: 1.1rem; width: 1.1rem; }\n.error-message { border-left: 3px solid var(--danger); color: var(--danger); padding: 10px; }\n.matrix-scroll { border: 1px solid #dce1e5; min-width: 100%; width: max-content; }\n.type-matrix { border-collapse: separate; border-spacing: 0; font-size: .83rem; width: max-content; }\n.type-matrix th, .type-matrix td { background: #fff; border-bottom: 1px solid #e3e7eb; border-right: 1px solid #e3e7eb; padding: 6px; }\n.type-matrix thead th { background: #f0f3f5; position: sticky; top: 0; z-index: 2; }\n.matrix-title-row th { height: 44px; }\n.type-matrix thead .matrix-title { background: #fff; text-align: center; }\n.matrix-title strong { color: var(--dark); display: block; font-size: .85rem; }\n.matrix-title small { color: var(--secondary); display: block; font-size: .7rem; }\n.type-matrix thead .period-row th { height: 44px; top: 44px; }\n.type-matrix thead .calibration-title-row th { top: 88px; }\n.period-weekly { --period-bg: #e6f3f0; --period-hover-bg: #d4eae4; --period-accent: #237667; }\n.period-monthly { --period-bg: #e9f2f9; --period-hover-bg: #d7e9f5; --period-accent: #326c96; }\n.period-quarterly { --period-bg: #eef4e6; --period-hover-bg: #e1edcf; --period-accent: #607f39; }\n.period-annual { --period-bg: #f9efe2; --period-hover-bg: #f4e4cb; --period-accent: #946327; }\n.type-matrix thead .period-band, .type-matrix thead .calibration-column { background: var(--period-bg); }\n.period-band { border-top: 3px solid var(--period-accent); color: var(--period-accent); font-weight: 700; text-align: center; }\n.type-column { left: 0; min-width: 340px; position: sticky; text-align: left; width: 340px; z-index: 1; }\n.type-matrix thead .type-column { z-index: 3; }\n.type-axis { align-items: center; display: inline-flex; gap: 8px; }\n.type-axis mat-icon { color: var(--primary); font-size: 18px; height: 18px; width: 18px; }\n.type-matrix tbody tr { height: 52px; }\n.type-content { align-items: center; display: flex; gap: 4px; width: 100%; }\n.type-name { flex: 1 1 auto; min-width: 0; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }\n.type-actions { display: inline-flex; flex: 0 0 auto; }\n.edit-name { flex: 1 1 auto; min-width: 0; width: 100%; }\n.calibration-column { height: 330px; max-width: 48px; min-width: 48px; padding: 4px !important; text-align: center; vertical-align: middle; width: 48px; }\n.calibration-column span { display: block; height: 310px; margin: 0 auto; overflow-wrap: anywhere; text-align: center; transform: rotate(180deg); white-space: normal; writing-mode: vertical-rl; }\n.type-matrix thead .calibration-column--active { background: var(--period-hover-bg); box-shadow: inset 0 0 0 2px var(--period-accent); z-index: 4; }\n.calibration-column--active span {\n\tbackground: #fff;\n\tborder: 2px solid var(--period-accent);\n\tbottom: 10px;\n\tbox-shadow: 0 3px 12px #0002;\n\tbox-sizing: border-box;\n\theight: auto;\n\tleft: 50%;\n\tmax-width: min(260px, calc(100vw - 32px));\n\toverflow-wrap: anywhere;\n\tpadding: 10px 12px;\n\tposition: absolute;\n\ttransform: translateX(-50%);\n\twhite-space: normal;\n\twidth: max-content;\n\twriting-mode: horizontal-tb;\n}\n.calibration-cell { height: 48px; text-align: center; width: 48px; }\n.calibration-cell--active { background: var(--period-hover-bg) !important; box-shadow: inset 0 0 0 2px var(--period-accent); }\n.type-matrix tbody .type-column--active { background: var(--period-hover-bg); box-shadow: inset 0 0 0 2px var(--period-accent); }\n.save-column { max-width: 72px; min-width: 72px; padding: 3px !important; text-align: center; width: 72px; }\n.inactive > th, .inactive > td { background: #f2f3f4; color: #6c757d; }\n.empty-row { padding: 20px !important; text-align: center; }\n@media (max-width: 700px) { .type-page { padding: .65rem; width: 100% !important; } .matrix-controls { align-items: stretch; flex-wrap: wrap; } .matrix-toolbar { margin-left: auto; } }\n@media (max-width: 600px) { .type-column { min-width: 260px; width: 260px; } .type-heading h1 { font-size: 1.3rem; } }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
